import { defineGameCard, drawCards, onAppear } from '../authoring/index.js';
export const ScoutCard = defineGameCard({
    id: 'scout',
    gameplay: {
        type: 'UNIT',
        cost: 1,
        baseStats: { attack: 1, health: 2 },
    },
    presentation: {
        name: 'Разведчик',
        description: 'При раскрытии: возьмите 1 карту.',
        glyph: {
            colors: ['#10213A', '#416C69', '#5EA17A', '#354B61', '#9AABB6'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '.......111111.......',
                '......12222331......',
                '.....1222443331.....',
                '.....1534354351.....',
                '.....1534334351.....',
                '.....1533443351.....',
                '.....1533333551.....',
                '......12555521......',
                '.....111222211......',
                '....4425555552122...',
                '....4412555521122...',
                '....1111222211.11...',
                '....21.11..11..21...',
                '......121..121......',
                '......441..1441.....',
                '....................',
            ],
        },
    },
    role: 'standalone_lab',
    abilities: [onAppear(drawCards(1), { cause: 'played' })],
});
//# sourceMappingURL=scout.js.map